import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cuándo recibo el ebook?',
  answer: 'Recibís el acceso de forma inmediata después de la compra. Podés empezar a leerlo en el momento, sin esperas.'
}, {
  question: '¿Cómo accedo al contenido?',
  answer: 'Una vez que comprás, te llega un link directo a tu email para descargar o ver el ebook online desde cualquier dispositivo.'
}, {
  question: '¿Necesito experiencia previa o conocimientos sobre el tema?',
  answer: 'No. Este ebook está pensado para que cualquier persona pueda entenderlo y aplicarlo, incluso si nunca trabajó estos temas antes.'
}, {
  question: '¿Funciona si hoy la conexión con mi pareja está muy apagada?',
  answer: 'Sí. Justamente está diseñado para situaciones donde la conexión bajó, hay rutina o distancia, y no sabés por dónde empezar.'
}, {
  question: '¿Qué pasa si me da vergüenza hablar de estos temas?',
  answer: 'No necesitás exponerte ni tener conversaciones incómodas desde el primer momento. El ebook te guía paso a paso para avanzar de forma natural y sin presión.'
}, {
  question: '¿En cuánto tiempo puedo empezar a ver cambios?',
  answer: 'Si aplicás lo que aprendés, podés empezar a notar cambios en pocos días, especialmente en tu seguridad, tu forma de actuar y la dinámica con tu pareja.'
}, {
  question: '¿Esto sirve si siento que el problema soy yo?',
  answer: 'Sí. El ebook trabaja justamente sobre esa sensación, ayudándote a recuperar seguridad y cambiar la forma en la que te posicionás en la relación.'
}, {
  question: '¿Puedo leerlo desde el celular?',
  answer: 'Sí. Podés acceder al ebook desde celular, tablet o computadora, en el formato que te resulte más cómodo.'
}, {
  question: '¿Qué pasa si no me gusta o siento que no es para mí?',
  answer: 'Tenés una garantía de 7 días. Si no te aporta valor, podés pedir la devolución sin complicaciones.'
}, {
  question: '¿Es contenido teórico o realmente práctico?',
  answer: 'Es 100% práctico. Incluye ejemplos reales, ejercicios y pasos concretos para que puedas aplicar desde el primer día.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 md:py-24 px-4" data-id="element-29">
      <div className="max-w-4xl mx-auto space-y-[16px]" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-31">
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-burgundy mb-6 font-[500]" data-id="element-32">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg md:text-xl text-charcoal/70" data-id="element-33">
            Resolvemos tus dudas
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-34">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-md overflow-hidden" data-id="element-35">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-blush/30 transition-colors" data-id="element-36">
                <span className="font-semibold text-charcoal text-lg pr-4" data-id="element-37">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-burgundy flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-38" />
              </button>
              <AnimatePresence data-id="element-39">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-40">
                    <div className="px-6 pb-5 text-charcoal/80 leading-relaxed" data-id="element-41">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}